<script setup>
import { has } from "core-js/internals/reflect-metadata";
import { computed, ref, watch } from "vue";

const fileModel = defineModel()

const inputRef = ref(null)
const imageRef = ref(null)
const wrapperContainer = ref(null)
const imageHeight = ref('200px')

const props = defineProps({
    description: {
        type: String,
        required: false,
        default: '클릭해서 업체 사진 첨부'
    }
})


const parseRejectReasons = (rejectReasons) => {
    let errors = []
    rejectReasons.forEach(fileError => {
        fileError.errors.forEach(err => {
            console.log(err.code)
            if (err.code === 'too-many-files') {
                errors.push('파일을 하나만 선택하세요.')
            } else if (err.code === 'file-too-large') {
                errors.push('파일 크기는 5MB 이하로 첨부 가능합니다. 사진 용량을 확인해주세요.')
            } else if (err.code === 'file-invalid-type') {
                errors.push('이미지 파일이 아닙니다. jpg, jpeg, png, gif 파일만 첨부 가능합니다.')
            } else {
                errors.push('알 수 없는 오류가 발생했습니다. 다시 시도해주세요.')
            }
        })
    })
    return errors[0]
}


const fileChange = async (event) => {

    if (event.target.files.length != 1) {
        imageHeight.value = '200px'
        fileModel.value = false
    }

    var file = event.target.files[0]
    var buff = await file.arrayBuffer();
    var clone = new File([buff],file.name, { type: file.type });

    fileModel.value = clone

    var img = new Image();
    img.src = URL.createObjectURL(clone);
    img.onload = function () {
        let wrapperContainerWidth = wrapperContainer.value.offsetWidth
        imageHeight.value = `${parseInt(img.height * wrapperContainerWidth / img.width)}px`
        imageRef.value.src = this.src
    }
    inputRef.value.value = ''
}

const fileInputClick = () => {
    inputRef.value.value = ''
    inputRef.value.click()
}

const hasImage = computed(() => {
    return fileModel.value !== null
})


</script>

<template>
    <div :style="{ backgroundSize: 'contain', backgroundColor: hasImage ? 'rgba(17, 17, 17, 0.48)' : 'none', border: hasImage ? 'none' : '', height: imageHeight }"
        class="file-input" @click="fileInputClick">
        <img style="width: 100%; height: 100%; position: absolute;" ref="imageRef">
        <div ref="wrapperContainer" :style="{ backgroundColor: hasImage ? 'rgba(17, 17, 17, 0.48)' : 'none' }"
            class="file-input-inner">
            <template v-if="hasImage">
                <svg class="mb-[8px]" fill="none" height="27" viewBox="0 0 35 27" width="35"
                    xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd"
                        d="M0.996827 0.98322C1.63434 0.353115 2.49796 0 3.39744 0H31.6026C32.502 0 33.3657 0.353115 34.0032 0.98322C34.6409 1.61349 35 2.46936 35 3.36282V19.8338C35 19.8351 35 19.8364 35 19.8377V23.6372C35 24.5306 34.6409 25.3865 34.0032 26.0168C33.3657 26.6469 32.502 27 31.6026 27H3.39744C2.49796 27 1.63434 26.6469 0.996827 26.0168C0.359145 25.3865 0 24.5306 0 23.6372V19.836C0 19.8358 0 19.8361 0 19.836V3.36282C0 2.46936 0.359145 1.61349 0.996827 0.98322ZM1.66667 20.1804V23.6372C1.66667 24.088 1.84781 24.5213 2.17186 24.8416C2.49607 25.1621 2.93683 25.343 3.39744 25.343H31.6026C32.0632 25.343 32.5039 25.1621 32.8281 24.8416C33.1522 24.5213 33.3333 24.088 33.3333 23.6372V20.1804L28.6065 15.5085C28.327 15.2322 27.9948 15.0127 27.6289 14.8629C27.263 14.7131 26.8707 14.636 26.4744 14.636C26.078 14.636 25.6857 14.7131 25.3198 14.8629C24.9539 15.0127 24.6218 15.2322 24.3422 15.5085L22.5282 17.3014L24.4978 19.2482C24.8242 19.5708 24.8257 20.0954 24.5013 20.4199C24.1768 20.7444 23.6491 20.7459 23.3227 20.4233L14.5039 11.707C14.2244 11.4307 13.8923 11.2113 13.5264 11.0615C13.1605 10.9117 12.7681 10.8345 12.3718 10.8345C11.9755 10.8345 11.5831 10.9117 11.2172 11.0615C10.8513 11.2113 10.5192 11.4307 10.2397 11.707L1.66667 20.1804ZM21.3462 16.1332L23.1672 14.3333C23.6019 13.9036 24.1178 13.563 24.6852 13.3307C25.2526 13.0984 25.8605 12.9789 26.4744 12.9789C27.0882 12.9789 27.6962 13.0984 28.2635 13.3307C28.8309 13.563 29.3468 13.9036 29.7815 14.3333L33.3333 17.8438V3.36282C33.3333 2.912 33.1522 2.47865 32.8281 2.15838C32.5039 1.83793 32.0632 1.65704 31.6026 1.65704H3.39744C2.93683 1.65704 2.49607 1.83793 2.17186 2.15838C1.84781 2.47865 1.66667 2.912 1.66667 3.36282V17.8438L9.06462 10.5319C9.49937 10.1022 10.0152 9.76157 10.5826 9.52928C11.15 9.29699 11.758 9.1775 12.3718 9.1775C12.9856 9.1775 13.5936 9.29699 14.161 9.52928C14.7284 9.76157 15.2442 10.1022 15.679 10.5319L21.3462 16.1332ZM20.3054 6.12868C20.5822 5.85503 20.9567 5.70217 21.3462 5.70217C21.7356 5.70217 22.1101 5.85503 22.3869 6.12868C22.664 6.40249 22.8205 6.77491 22.8205 7.16426C22.8205 7.55361 22.664 7.92603 22.3869 8.19984C22.1101 8.47349 21.7356 8.62635 21.3462 8.62635C20.9567 8.62635 20.5822 8.47349 20.3054 8.19984C20.0283 7.92603 19.8718 7.55361 19.8718 7.16426C19.8718 6.77491 20.0283 6.40249 20.3054 6.12868Z"
                        fill="white" fill-rule="evenodd" />
                </svg>
            </template>
            <template v-else>
                <svg class="mb-[8px]" fill="none" height="28" viewBox="0 0 35 28" width="35"
                    xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd"
                        d="M0.996827 1.48322C1.63434 0.853115 2.49796 0.5 3.39744 0.5H31.6026C32.502 0.5 33.3657 0.853115 34.0032 1.48322C34.6409 2.11349 35 2.96936 35 3.86282V20.3338C35 20.3351 35 20.3364 35 20.3377V24.1372C35 25.0306 34.6409 25.8865 34.0032 26.5168C33.3657 27.1469 32.502 27.5 31.6026 27.5H3.39744C2.49796 27.5 1.63434 27.1469 0.996827 26.5168C0.359145 25.8865 0 25.0306 0 24.1372V20.336C0 20.3358 0 20.3361 0 20.336V3.86282C0 2.96936 0.359145 2.11349 0.996827 1.48322ZM1.66667 20.6804V24.1372C1.66667 24.588 1.84781 25.0213 2.17186 25.3416C2.49607 25.6621 2.93683 25.843 3.39744 25.843H31.6026C32.0632 25.843 32.5039 25.6621 32.8281 25.3416C33.1522 25.0213 33.3333 24.588 33.3333 24.1372V20.6804L28.6065 16.0085C28.327 15.7322 27.9948 15.5127 27.6289 15.3629C27.263 15.2131 26.8707 15.136 26.4744 15.136C26.078 15.136 25.6857 15.2131 25.3198 15.3629C24.9539 15.5127 24.6218 15.7322 24.3422 16.0085L22.5282 17.8014L24.4978 19.7482C24.8242 20.0708 24.8257 20.5954 24.5013 20.9199C24.1768 21.2444 23.6491 21.2459 23.3227 20.9233L14.5039 12.207C14.2244 11.9307 13.8923 11.7113 13.5264 11.5615C13.1605 11.4117 12.7681 11.3345 12.3718 11.3345C11.9755 11.3345 11.5831 11.4117 11.2172 11.5615C10.8513 11.7113 10.5192 11.9307 10.2397 12.207L1.66667 20.6804ZM21.3462 16.6332L23.1672 14.8333C23.6019 14.4036 24.1178 14.063 24.6852 13.8307C25.2526 13.5984 25.8605 13.4789 26.4744 13.4789C27.0882 13.4789 27.6962 13.5984 28.2635 13.8307C28.8309 14.063 29.3468 14.4036 29.7815 14.8333L33.3333 18.3438V3.86282C33.3333 3.412 33.1522 2.97865 32.8281 2.65838C32.5039 2.33793 32.0632 2.15704 31.6026 2.15704H3.39744C2.93683 2.15704 2.49607 2.33793 2.17186 2.65838C1.84781 2.97865 1.66667 3.412 1.66667 3.86282V18.3438L9.06462 11.0319C9.49937 10.6022 10.0152 10.2616 10.5826 10.0293C11.15 9.79699 11.758 9.6775 12.3718 9.6775C12.9856 9.6775 13.5936 9.79699 14.161 10.0293C14.7284 10.2616 15.2442 10.6022 15.679 11.0319L21.3462 16.6332ZM20.3054 6.62868C20.5822 6.35503 20.9567 6.20217 21.3462 6.20217C21.7356 6.20217 22.1101 6.35503 22.3869 6.62868C22.664 6.90249 22.8205 7.27491 22.8205 7.66426C22.8205 8.05361 22.664 8.42603 22.3869 8.69984C22.1101 8.97349 21.7356 9.12635 21.3462 9.12635C20.9567 9.12635 20.5822 8.97349 20.3054 8.69984C20.0283 8.42603 19.8718 8.05361 19.8718 7.66426C19.8718 7.27491 20.0283 6.90249 20.3054 6.62868Z"
                        fill="#B7B7B7" fill-rule="evenodd" />
                </svg>
            </template>
            <p :class="[hasImage ? 'info-text-has-image' : 'info-text']">
                {{ props.description }}
            </p>
        </div>
    </div>
    <label class="sr-only" for="dropzone-file">파일</label>
    <input type="file" class="hidden" accept="image/*" ref="inputRef" @change="fileChange" />
</template>

<style>
.file-input {
    display: flex;
    height: 200px;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid #DFDFDF;
    cursor: pointer;
    background-position: center;
    margin-bottom: 4px;
}

.info-text {
    color: #B7B7B7;
    text-align: center;
    font-family: NanumSquare, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    /* 157.143% */
    user-select: none;
}

.info-text-has-image {
    color: #FCFCFC;
    text-align: center;
    font-family: NanumSquare, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    /* 157.143% */
}
</style>